import * as React from "react";
const SvgFiRrBeacon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-beacon_svg__a)">
      <path
        fill="#062147"
        d="M12.85.03C9.38-.21 5.97 1.06 3.51 3.52a12.03 12.03 0 0 0-3.48 9.33C.46 19.1 5.87 24 12.34 24H19c2.94 0 5-2.4 5-5.85v-5.82C24 5.87 19.1.46 12.85.03M22 18.15c0 2.3-1.21 3.85-3 3.85h-6.66c-5.42 0-9.95-4.08-10.31-9.28-.2-2.9.86-5.74 2.9-7.79A10.02 10.02 0 0 1 12.02 2c.23 0 .47 0 .7.02C17.93 2.38 22 6.91 22 12.33z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-beacon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBeacon;
